import nodeFetch from 'node-fetch';
import { config } from '_helpers';
import Event from 'linq';

const LogLevel = {
  0: 'off',
  1: 'fatal',
  3: 'error',
  7: 'warning',
  15: 'information',
  31: 'debug',
  63: 'verbose',
};

function StructuredLogConverter(evts) {
  return evts.map((evt) => {
    const renderedMsg = evt.messageTemplate.render(evt.properties);

    // Convert to properties format expected by log server.
    const properties = Event.from(Object.keys(evt.properties))
      .select((propertyName) => ({
        propertyName,
        propertyValue: evt.properties[propertyName],
      }))
      .toObject(
        (property) => property.propertyName,
        (property) => ({
          Value: property.propertyValue,
        })
      );

    return {
      Timestamp: evt.timestamp,
      Level: LogLevel[evt.level],
      MessageTemplate: evt.messageTemplate.raw,
      RenderedMessage: renderedMsg,
      Properties: properties,
    };
  });
}

function HttpSink() {
  const self = this;

  self.toString = () => 'HttpSink';
  self.emit = async (evts, done) => {
    const processedEvents = new StructuredLogConverter(evts);

    const body = {
      Logs: processedEvents,
    };

    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Ocp-Apim-Subscription-Key': '5a40d8df20394aedaf328de7c5d9d570',
        'Content-Type': 'application/json',
      },
    };

    try {
      await nodeFetch(`${config.apiUrl.loggingAPI}/logs`, requestOptions);
      console.log('Posted log message');
    } catch (e) {
      console.debug('Error posting log message');
      console.debug(e);
    }
    if (typeof done === 'function') {
      done();
    }
  };
}

export default HttpSink;
